import {
    apiRequest,
    PensiunList,
    masterWorkUnit
} from "../../../../../services/adapters/kepegawaian/dashboardService"

class IndexRepository {

    fetchPensiunList = async (query) => {
        return await apiRequest("get", PensiunList, {
            params: query
        }, true)
    }
    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }
}

export default IndexRepository